import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/PopularBuilder.css";
import analyticsService from "../../services/analyticsService";

import Lyk from "../assets/img/lyk.svg";
import DisLyk from "../assets/img/dislyk.svg";
import Frame from "../assets/img/FRAME.svg";
import AgentIcon from "../assets/img/Groupicn.svg";
import BookingIcon from "../assets/img/Booklead.svg";
import LeadIcon from "../assets/img/registerlead.svg";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import arrowleftt from "../assets/img/arrowleftt.svg"

export default function PopularBuildersPage() {
  const navigate = useNavigate();
  // EXACT React Native app state structure
  const [loading, setLoading] = useState(true);
  const [builders, setBuilders] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesByState, setCitiesByState] = useState({});
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => { loadInitialData(); }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      const citiesStatesResponse = await analyticsService.getCitiesAndStates('builder');
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        setStates([...new Set((citiesStatesResponse.data.states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort());
        setCitiesByState(citiesStatesResponse.data.citiesByState || {});
      }
      await loadBuilders();
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadBuilders = async (pageNum = 1) => {
    try {
      const filters = { page: pageNum, per_page: 20 };
      if (selectedCity) filters.city = selectedCity;
      if (selectedState) filters.state = selectedState;
      const response = await analyticsService.getPopularBuilders(filters);
      if (response.success && response.data) {
        setBuilders(response.data.items || []);
        setTotal(response.data.total || 0);
        setTotalPages(response.data.total_pages || 1);
        setPage(pageNum);
      } else {
        setBuilders([]); setTotal(0); setTotalPages(1); setPage(1);
      }
    } catch (error) {
      console.error('Error loading builders:', error);
      setBuilders([]); setTotal(0); setTotalPages(1);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    await loadBuilders(1);
    setLoading(false);
  };

  const handleStateChange = (e) => { setSelectedState(e.target.value); setSelectedCity(''); };
  const handleCityChange = (e) => { setSelectedCity(e.target.value); };
  const getFilteredCities = () => !selectedState ? [] : (citiesByState[selectedState] || []);

  // Image URL helper (EXACT React Native app logic)
  const getFullImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://sandbox.rebax.in';
    return `${API_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
  };

  return (
    <div className="pb-page">
      <LeftNav />
      <div className="pb-content-wrap">
        <TopNav />

        <div className="pb-container-card">
          <div className="pb-header-row">
            <div className="pb-header-left">
              <img src={arrowleftt} onClick={() => navigate("/webadmindashboard")} style={{ cursor: "pointer" }}></img>
              <h2 className="pb-page-title">Popular Builders</h2>
            </div>
            <div className="pb-filters-row">
              <div className="pb-filter-group">
                <label className="pb-label">State</label>
                <select value={selectedState} onChange={handleStateChange} className="pb-select" disabled={loading}>
                  <option value="">Select State</option>
                  {Array.isArray(states) ? states.map((state, idx) => (
                    <option key={idx} value={state}>{state}</option>
                  )) : []}
                </select>
              </div>

              {selectedState && (
                <div className="pb-filter-group">
                  <label className="pb-label">City</label>
                  <select value={selectedCity} onChange={handleCityChange} className="pb-select" disabled={loading}>
                    <option value="">Select City</option>
                    {getFilteredCities().map((city, idx) => (
                      <option key={idx} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
              )}

              <button className="pb-apply-btn" onClick={handleApply} disabled={loading}>
                {loading ? 'Loading...' : 'Apply'}
              </button>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
            </div>
          ) : builders.length === 0 ? (
            <div className="pb-empty-container">
              <p>No builders found</p>
              <button onClick={handleApply} className="pb-retry-btn">Retry</button>
            </div>
          ) : (
            <>
              <div className="pb-cards-grid">
                {builders.map((builder, index) => (
                  <BuilderCard
                    key={builder.id?.toString() || index.toString()}
                    rank={(page - 1) * 20 + index + 1}
                    data={builder}
                    getFullImageUrl={getFullImageUrl}
                    navigate={navigate}
                  />
                ))}
              </div>

              {/* Pagination (EXACT React Native app logic) */}
              {totalPages > 1 && (
                <div className="pb-pagination">
                  <button
                    className={`pb-page-btn ${page <= 1 ? 'disabled' : ''}`}
                    onClick={async () => {
                      if (page > 1 && !loading) {
                        setLoading(true);
                        try {
                          await loadBuilders(page - 1);
                        } finally {
                          setLoading(false);
                        }
                      }
                    }}
                    disabled={page <= 1 || loading}
                  >
                    ← Previous
                  </button>

                  <span className="pb-page-info">
                    Page {page} of {totalPages} ({total} total)
                  </span>

                  <button
                    className={`pb-page-btn ${page >= totalPages ? 'disabled' : ''}`}
                    onClick={async () => {
                      if (page < totalPages && !loading) {
                        setLoading(true);
                        try {
                          await loadBuilders(page + 1);
                        } finally {
                          setLoading(false);
                        }
                      }
                    }}
                    disabled={page >= totalPages || loading}
                  >
                    Next →
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function TopBar() {
  return (
    <div className="pb-topbar">
      <div className="pb-search-wrap">
        <span>🔍</span>
        <input placeholder="Search leads, projects, tasks…" className="pb-search-input" />
      </div>

      <div className="pb-topbar-right">
        <button title="Notifications" className="pb-icon-btn">🔔</button>
        <button title="Help" className="pb-icon-btn">❔</button>
        <div className="pb-profile-chip">
          <img alt="User" src={Frame} className="pb-profile-avatar" />
          <span className="pb-profile-name">Murali Krishna</span>
          <span style={{ opacity: 0.6 }}>▾</span>
        </div>
      </div>
    </div>
  );
}

function Sidebar() {
  const items = [
    { label: "Dashboard", icon: "▦" },
    { label: "Task Manager", icon: "✓" },
    { label: "CRM", icon: "👥" },
    { label: "Search", icon: "🔎" },
    { label: "Contacts", icon: "📇" },
  ];

  return (
    <aside className="pb-sidebar">
      <div className="pb-brand">REBAX</div>
      <nav style={{ display: "grid", gap: 6 }}>
        {items.map((it) => (
          <a key={it.label} href="#" className="pb-side-link">
            <span style={{ marginRight: 10 }}>{it.icon}</span>
            {it.label}
          </a>
        ))}
      </nav>
    </aside>
  );
}

function BuilderCard({ rank, data, getFullImageUrl, navigate }) {
  return (
    <div className="pb-card">
      <div className="pb-card-left-col">
        <div className="pb-rank-circle">{rank}</div>
      </div>

      <div style={{ display: "flex", alignItems: "flex-start", gap: 12, flex: 1, position: "relative" }}>
        <img
          src={getFullImageUrl(data.profile_image) || Frame}
          alt={data.full_name || 'Unknown Builder'}
          className="pb-avatar"
          onError={(e) => {
            e.target.src = Frame;
          }}
        />
        <div style={{ display: "grid", gap: 8, flex: 1 }}>
          <div className="pb-card-title-row">
            <span className="pb-card-title" style={{ cursor: "pointer" }} onClick={() => data?.id && navigate('/AdminAgencyViewBuilder', { state: { userId: data.id } })}>{data.full_name || 'Unknown Builder'}</span>
          </div>

          <ul className="pb-metrics-list">
            <Metric label="Registered Agents" value={data.registered_agents || 0} icon={AgentIcon} />
            <Metric label="Total Bookings" value={data.total_bookings || 0} icon={BookingIcon} />
            <Metric label="Registered Leads" value={data.registered_leads || 0} icon={LeadIcon} />
          </ul>
        </div>

        {/* Like/Dislike section positioned at top-right */}
        <div className="pb-rating-div" style={{
          position: "absolute",
          top: 0,
          right: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 6,
          fontSize: "13px"
        }}>
          <img src={Lyk} alt="Like" className="pb-badge-icon" />
          <span className="pb-rating-num">{data.likes || 0}</span>
          <img src={DisLyk} alt="Dislike" className="pb-badge-icon" />
          <span className="pb-rating-num">{data.dislikes || 0}</span>
        </div>
      </div>
    </div>
  );
}

function Metric({ label, value, icon }) {
  return (
    <li className="pb-metric-item">
      <img src={icon} alt={label} className="pb-metric-icon" />
      <span className="pb-metric-label">{label}</span>
      <span className="pb-metric-value">{value}</span>
    </li>
  );
}
